// We don't really care about the rtl languages: Arabic (ar), Hebrew (he), and Persian (fa)
// but at least I can put punctuation marks to the right side of the text

import angular from 'angular'

import { noop, isFunction, isPlainObject } from 'lodash-es'

angular
  .module('ggs')
  .decorator('roeBindDirective', AutoDirDecorator)
  .decorator('ggsTmplDirective', AutoDirDecorator)
  .decorator('ggsTimeagoDirective', AutoDirDecorator)
  .decorator('ngBindDirective', AutoDirDecorator)
  .decorator('ngBindHtmlDirective', AutoDirDecorator)

function AutoDirDecorator($delegate) {
  const orig = $delegate[0]
  const origCompile = orig.compile
  orig.compile = function delegateCompile() {
    let origPreLink = noop
    let origPostLink = noop
    const link = origCompile.apply(this, arguments)

    if (isFunction(link)) origPostLink = link
    if (isPlainObject(link) && isFunction(link.pre)) origPreLink = link.pre
    if (isPlainObject(link) && isFunction(link.post)) origPostLink = link.post

    return { pre: origPreLink, post: delegatePostLink }

    function delegatePostLink(_$scope, $element) {
      $element.attr('dir', 'auto')
      return origPostLink.apply(this, arguments)
    }
  }
  return $delegate
}
